module.exports = __webpack_public_path__ + "static/media/2LBloodCooler.490df57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/popups/temperatureSensorPopup/2LBloodCooler.png
// module id = 1316
// module chunks = 0